import "./LoadingIndicator.css";
const FADE_OUT_LOADING_RETRY_TIME = 1000;
export class LoadingIndicator {
    constructor(finishedLoading) {
        this.fadeOutLoading = () => {
            if (this.finishedLoading()) {
                this.loading.addEventListener("transitionend", () => {
                    this.loading.remove();
                });
                this.loading.classList.add("fadeout");
                return;
            }
            setTimeout(this.fadeOutLoading, FADE_OUT_LOADING_RETRY_TIME);
        };
        this.finishedLoading = finishedLoading;
        const element = document.getElementById("loading");
        if (!element) {
            throw new Error("Loading indicator not found in page");
        }
        this.loading = element;
        this.fadeOutLoading();
    }
}
